import React from 'react';
import useStyle from './containerFullWidth.style';
import { classNames } from 'helpers/style/classNames';

export interface ContainerFullWidthProps {
  children?: any;
  gap?: 'default' | 'small';
}

export const ContainerFullWidth = ({
  children,
  gap = 'default'
}: ContainerFullWidthProps) => {
  const classes = useStyle();

  return (
    <div className={classNames([classes.root, classes[gap]])}>{children}</div>
  );
};
